export default __webpack_public_path__ + "static/media/aditi.2e6c99d0.jpg";